import React, { useState, useEffect, useRef } from 'react';
import {
  makeStyles,
  ThemeProvider,
  withStyles,
} from '@mui/styles';
import { createTheme } from '@mui/material/styles';

import {
  Paper,
  Table,
  Checkbox,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import KeyHandler, { KEYPRESS } from 'react-key-handler';
import { COLORS } from 'src/constants/colors';
import { useSelector } from 'react-redux';

const theme = createTheme({
  overrides: {
    MuiTableRow: {
      root: {
        '&$selected, &$selected:hover': {
          backgroundColor: '#bedcfa',
        },
      },
      row: {
        height: 10,
      },
      head: {
        height: 10,
      },
    },
  },
});

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 420,
  },
  row: {
    border: 'none',
    height: 10,
  },
});

const CustomCheckbox = withStyles({
  root: {
    color: COLORS.cta_blue,
    '&$checked': {
      color: COLORS.cta_blue,
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function SupplierSearchTable({
  rows,
  rowSelected,
  multiSelection,
  checkedRows = [],
  setCheckedRows = () => { },
}) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [selected, setSelected] = useState(rows.length > 0 ? rows[0].code : '');
  const [rowData, setRows] = useState(rows);
  const [currentSelected, setCurrent] = useState(rows.length > 0 ? 0 : -1);
  const rowRef = useRef();
  const customizations = useSelector((state) => state.customizations);

  const columns = customizations?.supplier_search?.defaultColumns ?? [
    { id: 'code', label: 'Code', minWidth: 50 },
    { id: 'name', label: 'Name', minWidth: 200 },
    { id: 'city', label: 'City', minWidth: 50 },
    { id: 'address_1', label: 'Addr 1', minWidth: 60 },
    { id: 'address_2', label: 'Addr 2', minWidth: 60 },
    { id: 'address_3', label: 'Addr 3', minWidth: 60 },
    { id: 'pincode', label: 'Pincode', minWidth: 50 },
    { id: 'state', label: 'State', minWidth: 80 },
    { id: 'phone', label: 'Phone', minWidth: 80 },
    { id: 'gstin', label: 'GSTIN', minWidth: 80 },
    { id: 'email', label: 'Email', minWidth: 80 },
    { id: 'contact_person', label: 'Cont. Person', minWidth: 100 },
    { id: 'secondary_phone', label: 'Sec. Phone', minWidth: 80 },
    { id: 'sms_cell', label: 'SMS Phone', minWidth: 80 },
  ];
  function handleClick(row) {
    if (multiSelection) {
      handleRowCheck(row);
    } else {
      const data = [findArrayElement(rows, row.id)];
      rowSelected(data);
    }
  }

  function findArrayElement(array, id) {
    return array.find((obj) => {
      return obj.id === id;
    });
  }

  const isRowChecked = (id) => {
    return (checkedRows ?? []).findIndex((r) => r?.id == id) !== -1;
  };

  function keyUp() {
    if (currentSelected == -1) {
      setCurrent(0);
      setSelected(rows[0].id);

      setRows(
        rows.map((item) =>
          item.id === rows[0].id ? { ...item, code: 'changed' } : item,
        ),
      );
    } else if (currentSelected > -1) {
      if (currentSelected == 0) {
        var val = rows.length - 1;
        setCurrent(val);
        setSelected(rows[val].id);

        setRows(
          rows.map((item) =>
            item.id === rows[val].id ? { ...item, code: 'changed' } : item,
          ),
        );
      } else {
        var val = currentSelected - 1;
        setCurrent(val);
        setSelected(rows[val].id);

        setRows(
          rows.map((item) =>
            item.id === rows[val].id ? { ...item, code: 'changed' } : item,
          ),
        );
      }
    }
    rowRef.current.scrollIntoView({
      behaviour: 'smooth',
      block: 'end',
      inline: 'start',
    });
  }

  function keyDown() {
    if (currentSelected < rows.length - 1) {
      const val = currentSelected + 1;

      setCurrent(val);
      setSelected(rows[val].id);

      setRows([...rows]);
    } else if (currentSelected == rows.length - 1) {
      setCurrent(0);
      setSelected(rows[0].id);

      setRows([...rows]);
    }
    console.log(rows.length);
    rowRef.current.scrollIntoView({
      behaviour: 'smooth',
      block: 'end',
      inline: 'start',
    });
  }

  function rowClicked() {
    if (currentSelected == -1) {
    } else {
      const data = [findArrayElement(rows, rows[currentSelected].id)];
      rowSelected(data);
    }
  }

  const handleRowCheck = (row) => {
    let previousRows = checkedRows ?? [];
    const selectedIndex = previousRows.findIndex((r) => r?.id == row?.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(previousRows, {
        ...row,
        id: row?.id,
        value: row?.name,
        label: row?.name,
      });
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(previousRows.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(previousRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        previousRows.slice(0, selectedIndex),
        previousRows.slice(selectedIndex + 1),
      );
    }
    setCheckedRows(newSelected);
  };

  const handleAllRowCheck = (event) => {
    let previousRows = [...(checkedRows ?? [])];
    if (event.target.checked == true) {
      rows?.forEach((row) => {
        const selectedIndex = previousRows.findIndex((r) => r?.id == row?.id);
        if (selectedIndex === -1) {
          previousRows.push({
            id: row?.id,
            value: row?.name,
            label: row?.name,
          });
        }
      });
      setCheckedRows(previousRows);
    } else if (event.target.checked == false) {
      setCheckedRows([]);
    }
  };

  return (
    <Paper className={classes.root} elevation={0}>
      <KeyHandler keyValue="ArrowUp" onKeyHandle={keyUp} />
      <KeyHandler keyValue="ArrowDown" onKeyHandle={keyDown} />
      <KeyHandler
        keyEventName={KEYPRESS}
        keyValue="Enter"
        onKeyHandle={rowClicked}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader size="small" aria-label="sticky table">
          <TableHead>
            <TableRow>
              {multiSelection ? (
                <TableCell key="multiselect" align="center" padding="checkbox">
                  <CustomCheckbox
                    checked={
                      rows?.length === checkedRows?.length && rows?.length > 0
                        ? true
                        : false
                    }
                    onChange={(event) => handleAllRowCheck(event)}
                  />
                </TableCell>
              ) : (
                <></>
              )}
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{
                    minWidth: column.minWidth,
                    background: '#000000',
                    color: '#ffffff',
                    height: '10px',
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row) => {
              return (
                <ThemeProvider theme={theme}>
                  <TableRow
                    hover
                    className={classes.row}
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    selected={row.id === selected}
                    ref={row.id === selected ? rowRef : null}
                    onClick={() => handleClick(row)}
                  >
                    {multiSelection ? (
                      <TableCell
                        key="multiselect"
                        align="center"
                        padding="checkbox"
                      >
                        <CustomCheckbox
                          checked={isRowChecked(row.id)}
                          onChange={(event) => handleRowCheck(row)}
                        />
                      </TableCell>
                    ) : (
                      <></>
                    )}
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </ThemeProvider>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
